import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
@Component({
  selector: 'xchange-progress-modal',
  templateUrl: './progress-modal.component.html',
  styleUrl: './progress-modal.component.scss'
})
export class ProgressModalComponent {
  modalId: any;
  progressText: string = "Processing";
  multipleProgressText: any = []
  multipleProgressInterval: number = 4;
  
  constructor(
    private modalService: BsModalService,
  ) { }

  ngOnInit(): void {
    if (this.multipleProgressText.length) {
      //@rehan_rizvi: TODO: reffactor it for multiple messages
      this.progressText = this.multipleProgressText[0];
      setTimeout(() => {
        this.progressText = this.multipleProgressText[1] || this.progressText;
      }, this.multipleProgressInterval * 1000)
    }
  }
}
